import { render, staticRenderFns } from "./PaginationBtns.vue?vue&type=template&id=01f4e246&"
import script from "./PaginationBtns.vue?vue&type=script&lang=js&"
export * from "./PaginationBtns.vue?vue&type=script&lang=js&"
import style0 from "./PaginationBtns.vue?vue&type=style&index=0&id=01f4e246&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports